import React from 'react';
import { TrendingUpIcon, ClockIcon, DollarSignIcon } from 'lucide-react';
export function Proof() {
  const results = [{
    icon: ClockIcon,
    metric: '80-90%',
    label: 'TASK COMPLETION',
    description: 'Insurance brokerage, business process automation',
    detail: 'AI-powered workflow automation handles routine policy processing, claims validation, and customer communications. Team now focuses on complex cases and relationship building.',
    color: 'amber'
  }, {
    icon: TrendingUpIcon,
    metric: '200%',
    label: 'LEAD GENERATION INCREASE',
    description: 'Business networking & conference company, lead gen content',
    detail: 'AI content automation system generates personalized outreach, event promotions, and follow-up sequences. Tripled lead generation while maintaining quality and brand voice.',
    color: 'green'
  }, {
    icon: DollarSignIcon,
    metric: '50%',
    label: 'CONVERSION LIFT',
    description: 'Manufacturing company, custom AI proposal system',
    detail: 'Intelligent proposal generation that adapts to client needs, pulls relevant case studies, and personalizes pricing. Converted 50% more leads into paying customers.',
    color: 'amber'
  }];
  return <div className="w-full bg-black py-24 relative overflow-hidden" data-id="element-405">
      <div className="absolute inset-0 opacity-5 animate-pulse-grid" style={{
      backgroundImage: 'radial-gradient(circle at 50% 50%, #ffa500 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-406" />
      {/* Floating particles */}
      {[...Array(25)].map((_, i) => <div key={i} className="absolute rounded-full animate-float" style={{
      width: `${2 + Math.random() * 3}px`,
      height: `${2 + Math.random() * 3}px`,
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      backgroundColor: i % 2 === 0 ? '#22c55e' : '#f59e0b',
      animationDelay: `${Math.random() * 5}s`,
      animationDuration: `${10 + Math.random() * 15}s`,
      opacity: 0.3
    }} data-id="element-407" />)}
      <div className="container mx-auto px-6 relative z-10" data-id="element-408">
        <div className="max-w-5xl mx-auto" data-id="element-409">
          {/* Header */}
          <div className="mb-16 animate-fade-in-up" data-id="element-410">
            <div className="inline-block border-4 border-green-500 bg-black px-6 py-3 mb-6 shadow-[0_0_40px_rgba(0,255,0,0.4)] animate-glow-green" data-id="element-411">
              <h2 className="text-4xl md:text-5xl font-bold text-green-400 font-mono" data-id="element-412">
                PROOF
              </h2>
            </div>
            <p className="text-amber-500 text-xl font-mono mb-4 animate-fade-in-up" style={{
            animationDelay: '0.2s'
          }} data-id="element-413">
              // REAL AI AUTOMATION RESULTS, NOT TESTIMONIALS
            </p>
            <p className="text-amber-100 text-lg leading-relaxed animate-fade-in-up" style={{
            animationDelay: '0.3s'
          }} data-id="element-414">
              We don't do case studies or testimonials. We share numbers. Here's
              what happens when AI automation is applied to workflows that drive
              profit.
            </p>
          </div>
          {/* Results */}
          <div className="space-y-8" data-id="element-415">
            {results.map((result, index) => <div key={index} className={`border-4 ${result.color === 'amber' ? 'border-amber-600' : 'border-green-500'} bg-zinc-950 p-8 shadow-[0_0_40px_rgba(${result.color === 'amber' ? '255,165,0' : '0,255,0'},0.2)] hover:shadow-[0_0_60px_rgba(${result.color === 'amber' ? '255,165,0' : '0,255,0'},0.5)] hover:scale-[1.02] transition-all duration-500 animate-fade-in-up group relative overflow-hidden`} style={{
            animationDelay: `${0.4 + index * 0.1}s`
          }} data-id="element-416">
                <div className={`absolute inset-0 bg-gradient-to-br from-${result.color === 'amber' ? 'amber' : 'green'}-950/0 via-${result.color === 'amber' ? 'amber' : 'green'}-950/10 to-${result.color === 'amber' ? 'amber' : 'green'}-950/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500`} data-id="element-417" />
                {/* Corner accents */}
                <div className={`absolute top-2 left-2 w-6 h-6 border-t-2 border-l-2 ${result.color === 'amber' ? 'border-amber-400' : 'border-green-400'} animate-pulse`} data-id="element-418" />
                <div className={`absolute bottom-2 right-2 w-6 h-6 border-b-2 border-r-2 ${result.color === 'amber' ? 'border-amber-400' : 'border-green-400'} animate-pulse`} style={{
              animationDelay: '0.5s'
            }} data-id="element-419" />
                <div className="flex flex-col md:flex-row items-center gap-8 relative z-10" data-id="element-420">
                  {/* Metric */}
                  <div className="flex-shrink-0" data-id="element-421">
                    <div className={`border-2 ${result.color === 'amber' ? 'border-amber-500 bg-amber-950' : 'border-green-500 bg-green-950'} w-20 h-20 flex items-center justify-center mx-auto mb-4 group-hover:scale-110 group-hover:rotate-12 transition-all duration-500 relative overflow-hidden`} data-id="element-422">
                      <div className={`absolute inset-0 ${result.color === 'amber' ? 'bg-amber-500' : 'bg-green-500'} opacity-0 group-hover:opacity-20 transition-opacity duration-500`} data-id="element-423" />
                      <result.icon className={`w-10 h-10 ${result.color === 'amber' ? 'text-amber-500' : 'text-green-400'} animate-pulse relative z-10`} data-id="element-424" />
                    </div>
                    <div className={`text-5xl font-bold ${result.color === 'amber' ? 'text-amber-500' : 'text-green-400'} font-mono mb-2 group-hover:text-glow transition-all duration-300 text-center`} data-id="element-425">
                      {result.metric}
                    </div>
                    <div className={`text-sm font-mono ${result.color === 'amber' ? 'text-amber-300' : 'text-green-300'} text-center`} data-id="element-426">
                      {result.label}
                    </div>
                  </div>
                  {/* Details */}
                  <div className="flex-grow flex flex-col justify-center" data-id="element-427">
                    <p className="text-amber-500 font-mono text-sm mb-3 flex items-center gap-2" data-id="element-428">
                      <span className="w-2 h-2 bg-amber-500 animate-pulse" data-id="element-429" />
                      {'>'} {result.description}
                    </p>
                    <p className="text-amber-100 leading-relaxed text-lg mb-4" data-id="element-430">
                      {result.detail}
                    </p>
                    <div className={`h-1 w-0 group-hover:w-full ${result.color === 'amber' ? 'bg-amber-500' : 'bg-green-400'} transition-all duration-500`} data-id="element-431" />
                  </div>
                </div>
              </div>)}
          </div>
          {/* Bottom note */}
          <div className="mt-12 border-4 border-amber-600 bg-black p-8 animate-fade-in-up hover:shadow-[0_0_40px_rgba(255,165,0,0.3)] transition-all duration-500 group relative overflow-hidden" style={{
          animationDelay: '0.7s'
        }} data-id="element-432">
            <div className="absolute inset-0 bg-gradient-to-r from-amber-950/0 via-amber-950/20 to-amber-950/0 transform -translate-x-full group-hover:translate-x-full transition-transform duration-1000" data-id="element-433" />
            <div className="absolute top-2 left-2 w-8 h-8 border-t-2 border-l-2 border-amber-400 animate-pulse" data-id="element-434" />
            <div className="absolute bottom-2 right-2 w-8 h-8 border-b-2 border-r-2 border-amber-400 animate-pulse" style={{
            animationDelay: '0.5s'
          }} data-id="element-435" />
            <p className="text-amber-100 leading-relaxed mb-4 relative z-10" data-id="element-436">
              <span className="text-amber-500 font-semibold" data-id="element-437">
                Pattern you'll notice:
              </span>{' '}
              AI automation delivers measurable business impact when applied to
              workflows that directly drive profit—task completion, lead
              generation, and conversion rates.
            </p>
            <p className="text-amber-100 leading-relaxed relative z-10" data-id="element-438">
              That's the uncomfortable truth most vendors won't tell you:{' '}
              <span className="text-green-400 font-semibold" data-id="element-439">
                AI automation without profit-focused workflow design is just
                expensive complexity
              </span>
              . But we're partners, not vendors. So we'll tell you.
            </p>
          </div>
        </div>
      </div>
      <style data-id="element-440">{`
        @keyframes pulse-grid {
          0%, 100% { opacity: 0.05; }
          50% { opacity: 0.1; }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0) translateX(0) rotate(0deg); }
          50% { transform: translateY(-100px) translateX(50px) rotate(180deg); }
        }
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes glow-green {
          0%, 100% { box-shadow: 0 0 40px rgba(0, 255, 0, 0.4); }
          50% { box-shadow: 0 0 60px rgba(0, 255, 0, 0.7); }
        }
        .animate-pulse-grid {
          animation: pulse-grid 4s ease-in-out infinite;
        }
        .animate-float {
          animation: float linear infinite;
        }
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
          opacity: 0;
        }
        .animate-glow-green {
          animation: glow-green 3s ease-in-out infinite;
        }
        .text-glow {
          text-shadow: 0 0 20px currentColor;
        }
      `}</style>
    </div>;
}